import PropTypes from "prop-types";
import { useFormContext, Controller } from "react-hook-form";
import { TextField } from "@mui/material";

RHFTextFieldAdd.propTypes = {
  name: PropTypes.string,
  helperText: PropTypes.node,
};

export default function RHFTextFieldAdd({
  name,
  helperText,
  ...other
}) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          value={field.value !== undefined ? field.value : ""}
          error={!!error }
          helperText={error ? error?.message : helperText}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: 0,
              fontSize: "1.6rem",
              position: "relative",
              marginTop: "0.4rem",
            },
            "& .MuiFormHelperText-root": {
              color: "red",
              fontSize: "1.2rem",
              marginLeft: "8px",
            },
          }}
          {...other}
        />
      )}
    />
  );
}
